var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResultsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.561,
    height: 123.618,
    viewBox: "0 0 163.561 123.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21154",
    "data-name": "Group 21154",
    transform: "translate(-40.108 -302)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1103",
    "data-name": "Ellipse 1103",
    cx: 61.477,
    cy: 61.477,
    r: 61.477,
    transform: "translate(61.871 302.663)",
    fill: "#d8e0eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19101",
    "data-name": "Path 19101",
    d: "M279.174,162.564v-6.182a4.445,4.445,0,0,0-4.445-4.445H259.041a4.445,4.445,0,0,1-4.445-4.445v-6.182a4.445,4.445,0,0,1,4.445-4.445h.5a4.445,4.445,0,0,0,4.445-4.445V126.24a4.445,4.445,0,0,0-4.445-4.445H145.555a4.445,4.445,0,0,0-4.445,4.445v6.182a4.445,4.445,0,0,0,4.445,4.445h0A4.445,4.445,0,0,1,150,141.311v6.182a4.445,4.445,0,0,1-4.445,4.445H128.367a4.445,4.445,0,0,0-4.445,4.445v6.182a4.445,4.445,0,0,0,4.445,4.445h6.744a4.445,4.445,0,0,1,4.445,4.445v6.182a4.445,4.445,0,0,1-4.445,4.445h-.016a4.445,4.445,0,0,0-4.445,4.445v6.182a4.445,4.445,0,0,0,4.445,4.445h.976a4.445,4.445,0,0,1,4.445,4.445v6.182a4.445,4.445,0,0,1-4.445,4.445H120.057a4.445,4.445,0,0,0-4.445,4.445v6.182a4.445,4.445,0,0,0,4.445,4.445H261.923a4.445,4.445,0,0,0,4.445-4.445v-6.182a4.445,4.445,0,0,0-4.445-4.445h-3.854a4.445,4.445,0,0,1-4.445-4.445v-6.182a4.445,4.445,0,0,1,4.445-4.445h9.087a4.445,4.445,0,0,0,4.445-4.445v-6.182a4.445,4.445,0,0,0-4.445-4.445H264.4a4.445,4.445,0,0,1-4.445-4.445v-6.182a4.445,4.445,0,0,1,4.445-4.445h10.33a4.445,4.445,0,0,0,4.445-4.445Z",
    transform: "translate(-75.504 189.597)",
    fill: "#d9e1eb"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    x2: 11.843,
    transform: "translate(148.508 309.719)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    x2: 11.843,
    transform: "translate(148.508 313.132)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    x2: 11.843,
    transform: "translate(148.508 316.545)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    x2: 11.843,
    transform: "translate(156.712 404.719)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    x2: 11.843,
    transform: "translate(156.712 408.132)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    x2: 11.843,
    transform: "translate(156.712 411.546)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_116",
    "data-name": "Line 116",
    x2: 11.843,
    transform: "translate(58.433 348.264)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    x2: 11.843,
    transform: "translate(58.433 351.677)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    x2: 11.843,
    transform: "translate(58.433 355.09)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1104",
    "data-name": "Ellipse 1104",
    cx: 5.062,
    cy: 5.062,
    r: 5.062,
    transform: "translate(111.766 409.319)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1105",
    "data-name": "Ellipse 1105",
    cx: 2.625,
    cy: 2.625,
    r: 2.625,
    transform: "translate(107.454 399.664)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1106",
    "data-name": "Ellipse 1106",
    cx: 3.749,
    cy: 3.749,
    r: 3.749,
    transform: "translate(123.498 401.164)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1107",
    "data-name": "Ellipse 1107",
    cx: 6.023,
    cy: 6.023,
    r: 6.023,
    transform: "translate(56.941 379.219)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1108",
    "data-name": "Ellipse 1108",
    cx: 3.137,
    cy: 3.137,
    r: 3.137,
    transform: "translate(48.318 377.815)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1109",
    "data-name": "Ellipse 1109",
    cx: 1.81,
    cy: 1.81,
    r: 1.81,
    transform: "translate(52.527 368.479)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1110",
    "data-name": "Ellipse 1110",
    cx: 4.338,
    cy: 4.338,
    r: 4.338,
    transform: "translate(60.016 367.231)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1111",
    "data-name": "Ellipse 1111",
    cx: 6.023,
    cy: 6.023,
    r: 6.023,
    transform: "translate(94.848 311.394)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1112",
    "data-name": "Ellipse 1112",
    cx: 3.137,
    cy: 3.137,
    r: 3.137,
    transform: "translate(97.979 302)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1113",
    "data-name": "Ellipse 1113",
    cx: 2.715,
    cy: 2.715,
    r: 2.715,
    transform: "translate(119.296 304.255)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1114",
    "data-name": "Ellipse 1114",
    cx: 1.81,
    cy: 1.81,
    r: 1.81,
    transform: "translate(110.322 302.522)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1115",
    "data-name": "Ellipse 1115",
    cx: 4.338,
    cy: 4.338,
    r: 4.338,
    transform: "translate(109.898 309.871)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2669",
    "data-name": "Rectangle 2669",
    width: 7.101,
    height: 7.101,
    transform: "translate(87.885 379.492) rotate(29.699)",
    fill: "#dbe8ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19124",
    "data-name": "Path 19124",
    d: "M198.292,384.993l4.774,2.723h0Z",
    transform: "translate(-125.891 29.197)",
    fill: "#409cb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19126",
    "data-name": "Path 19126",
    d: "M180.7,374.816l1.15-2.016a.781.781,0,0,1,1.066-.292l9.833,5.608a.792.792,0,0,0-.124-.088l-12.045-6.87a.781.781,0,0,0-1.066.292l-1.15,2.016a5.146,5.146,0,0,0,1.92,7.019l2.081,1.187A5.142,5.142,0,0,1,180.7,374.816Z",
    transform: "translate(-113.334 37.69)",
    fill: "#e8eeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19127",
    "data-name": "Path 19127",
    d: "M195.813,389.794l1.15-2.016a.781.781,0,0,0-.292-1.066l-2.468-1.407a.781.781,0,0,1,.29,1.064l-1.15,2.016a5.146,5.146,0,0,1-7.019,1.92l-2-1.139,0,0,4.463,2.545A5.146,5.146,0,0,0,195.813,389.794Z",
    transform: "translate(-117.381 29.006)",
    fill: "#bad5db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2670",
    "data-name": "Rectangle 2670",
    width: 12.936,
    height: 30.728,
    rx: 2,
    transform: "translate(81.843 384.199) rotate(29.699)",
    fill: "#356ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19122",
    "data-name": "Path 19122",
    d: "M207.747,347.839,222.2,322.5a.781.781,0,0,0-.292-1.065l-2.457-1.4a.781.781,0,0,1,.291,1.065l-14.45,25.335a.781.781,0,0,1-1.066.292l2.457,1.4a.781.781,0,0,0,1.066-.291Z",
    transform: "translate(-129.506 68.783)",
    fill: "#214e8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19123",
    "data-name": "Path 19123",
    d: "M186.69,336.019l14.45-25.335a.781.781,0,0,1,1.066-.292l2.729,1.557-5.105-2.912a.781.781,0,0,0-1.066.291l-14.45,25.335a.781.781,0,0,0,.292,1.066l2.376,1.355A.781.781,0,0,1,186.69,336.019Z",
    transform: "translate(-117.31 75.549)",
    fill: "#5083c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19125",
    "data-name": "Path 19125",
    d: "M.781,0H14.648a.781.781,0,0,1,.781.781V3.1a5.146,5.146,0,0,1-5.146,5.146H5.146A5.146,5.146,0,0,1,0,3.1V.781A.781.781,0,0,1,.781,0Z",
    transform: "translate(66.569 408.461) rotate(29.699)",
    fill: "#dbe8ec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5704",
    "data-name": "Group 5704",
    transform: "translate(102.825 334.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1678_",
    d: "M64.031,42.243H8.29A3.3,3.3,0,0,1,5,38.953V8.29A3.3,3.3,0,0,1,8.29,5H64.031a3.3,3.3,0,0,1,3.29,3.29V38.953A3.3,3.3,0,0,1,64.031,42.243Z",
    transform: "translate(-5 -5)",
    fill: "#33383f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1677_",
    d: "M5,45H67.32V72.312H5Z",
    transform: "translate(-5 -40.035)",
    fill: "#f2665d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1418_",
    d: "M218,126.435V117l8.262,4.717Z",
    transform: "translate(-191.002 -103.097)",
    fill: "#fffcfa"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1116",
    "data-name": "Ellipse 1116",
    cx: 19.755,
    cy: 19.755,
    r: 19.755,
    transform: "translate(83.07 342.076)",
    fill: "#fff",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19121",
    "data-name": "Path 19121",
    d: "M270.934,253.155a14.131,14.131,0,0,1-26.511,5.9",
    transform: "translate(-154.004 109.542)",
    fill: "none",
    stroke: "#dbe8ec",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19120",
    "data-name": "Path 19120",
    d: "M252.676,232.241a24.535,24.535,0,1,0-34.364-4.821A24.535,24.535,0,0,0,252.676,232.241Zm-30.544-7.7a19.755,19.755,0,1,1,27.665,3.879A19.755,19.755,0,0,1,222.131,224.545Z",
    transform: "translate(-135.078 149.179)",
    fill: "#356ab3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsIcon);
export default __webpack_public_path__ + "static/media/NoResultsIcon.1b87e0d4ddbf7494bb07c9dddc85af80.svg";
export { ForwardRef as ReactComponent };